<script>
	import { createEventDispatcher } from 'svelte';
	import Identity from 'svelte-key'
    import { fly } from 'svelte/transition';
	import { pin, image, book } from 'ionicons/icons/index.mjs';
    import Details from './Details.svelte';
    import Media from './Media.svelte';
    import History from './History.svelte';

		export let tab = "details";
		export let isPublic;
    export let selected;
    export let config;
	export let session;
	export let keys;
	export let tooltips;

	
	const dispatch = createEventDispatcher();
	function sendMessage(message) {
		dispatch('message', message);
  }
</script>

<div id="callout" class="panel" transition:fly="{{ y: -36, duration: 500 }}">
	<div class="panel-header p-2">
		<div class="btn-group btn-group-block">
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "details" ? "active" : ""}" data-tooltip="Details"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "details",
					data: "details"
				})
			}}><i class="svg">{@html pin.md}</i></button>
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "media" ? "active" : ""}" data-tooltip="Media"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "details",
					data: "media"
				})
			}}><i class="svg">{@html image.md}</i></button>
			<button class="btn btn-sm {tooltips ? "tooltip tooltip-bottom" : ""} {tab == "history" ? "active" : ""}" data-tooltip="History"  on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
				sendMessage({
					type: "details",
					data: "history"
				})
			}}><i class="svg">{@html book.md}</i></button>
		</div> 
					{#if selected.features && selected.features.length > 1}
				<div class="tile tile-centered pt-1">
						<div class="tile-icon">
							<button class="btn btn-sm btn-link" on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
								if (selected.index != 0) {
									var index = selected.index - 1;
									sendMessage({
										type: "select-index",
										data: index
									})
								}
							}}>
								<i class="icon icon-arrow-left centered"></i>
							</button>
						</div>
						<div class="tile-content text-center">
								<div class="tile-title">{selected.index + 1} of {selected.features.length}</div>
						</div>
						<div class="tile-action">
								<button class="btn btn-sm btn-link" on:click|stopPropagation={(e) => {
                e.currentTarget.blur();
									if (selected.index != selected.features.length - 1) {
										var index = selected.index + 1;
										sendMessage({
											type: "select-index",
											data: index
										})
									}
								}}>
								<i class="icon icon-arrow-right centered"></i>
							</button>
						</div>
				</div>  
			{/if}
	</div>
	<div class="panel-body">
		<Identity key={keys.feature}>
			{#if tab == "details"}
				<Details tooltips={tooltips} isPublic={isPublic} feature={selected.feature} layer={selected.layer} />
			{:else if tab == "media"}
				<Media tooltips={tooltips} feature={selected.feature} layer={selected.layer} role={config.role} session={session} on:message />
			{:else if tab == "history"}
				<History tooltips={tooltips} feature={selected.feature} layer={selected.layer} role={config.role} session={session} on:message />
			{/if}
		</Identity>
	</div>
</div>

<style>
    #callout {
        position: fixed;
        right: 0;
        top: 4rem;
        overflow-y: auto;
        width: 300px;
        height: calc(100% - 4rem);
        box-shadow: 0 0 1rem rgba(0,0,0,.3), 0 0 12px rgba(0,0,0,.22);
	}
	.panel {
        border: 0;
        border-radius: 0;
        background-color: white;
	}
	.panel .panel-body {
		padding: 0;
    }
	.panel .panel-header {
		padding: 0;
		background: #efefef;
	}
	.svg {
		fill: #00ab5f;
	}
	.active .svg {
		fill: white;
    }
    ::-webkit-scrollbar {
		width: 6px;
		background-color: #f7f8f9;
	}
	::-webkit-scrollbar-thumb {
		background-color: rgba(122,129,132, 1);
	}
    @media screen and (max-width: 480px) {
		#callout {
			width: 265px;
			top: 4rem;
			height: calc(100% - 4rem);
		}
	}
</style>
